const getDirectionsUrl = ({ streetName , town , opco  })=>{
    return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent([
        ...streetName.split(' '),
        town,
        opco
    ].join(' ').trim())}`;
};

export { getDirectionsUrl };
//# sourceMappingURL=google-maps.js.map
